/**
 * PontaSla
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {PontaSlaCollection} from '@/model/collection/PontaSlaCollection'

/* TODO: review generated class */
export class PontaSla extends Resource {
  idPontaSlaPk: number = 0

  abreviacao: string | null = null
  uf: string | null = null
  naCapital: boolean | null = null

  cidade: string | null = null

  get $id() {
    return this.idPontaSlaPk
  }
  set $id(val) {
    this.idPontaSlaPk = val
  }

  /**
   * Gets a instance of a given ID of PontaSla
   */
  async getPontaSla(id: number) {
    return await Request.get(`/admin/ponta-sla/${id}`)
      .name('getPontaSla')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of PontaSla
   */
  static async listPontaSla(params: any) {
    return await Request.get(`/admin/ponta-sla`, {params})
      .name('listPontaSla')
      .as(PontaSlaCollection)
      .getData()
  }

  /**
   * Persists a new instance of PontaSla. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistPontaSla() {
    return await Request.post(`/admin/ponta-sla`, this)
      .name('persistPontaSla')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of PontaSla to use it in a CSV file
   */
  static async listCsvPontaSla(params: any) {
    return await Request.get(`/admin/ponta-sla/csv`, {params})
      .name('listCsvPontaSla')
      .as(PontaSlaCollection)
      .getData()
  }
}
